// Ajuste o padding top da body de acordo com a altura do menu
function setBodyPdTop() {
  let pdTop = 0;
  let headerHeight = 0;
  if ($('.header.fixed').length > 0) {
    headerHeight = $('.header.fixed').outerHeight();
    pdTop += headerHeight;
  }
  if ($('.menu-full.fixed').length > 0) {
    pdTop += $('.menu-full.fixed').outerHeight();
  }
  $('#menu').css('top', headerHeight);
  $('body').css('padding-top', pdTop);
}
setBodyPdTop();
$(window).on(
  'hresize ',
  debounce(function () {
    setBodyPdTop();
  }, 100),
);

// Oculto ou exibe o menu ao relizar o scroll na página
(function () {
  'use strict';
  const $menu = $('.menu-full.fixed');
  let lastScrollTop = 200;
  if ((isMedia('xl') || isMedia('lg')) && $menu.length > 0) {
    $(window).on(
      'scroll',
      debounce(function () {
        if ($('.menu-full').hasClass('fixed')) {
          const scrollTop = $(window).scrollTop() >= 0 ? $(window).scrollTop() : 0;
          if (scrollTop > lastScrollTop) {
            $menu.addClass('hidden');
          } else {
            $menu.removeClass('hidden');
          }
          lastScrollTop = scrollTop;
        }
      }, 50),
    );
  }
})();

// Exibe / Oculta busca mobile
(function () {
  'use strict';

  // Variáveis
  const $searchBtnToggle = $('.header-search-btn-mb');
  const $searchEl = $('.header-search-wrp');
  const $searchInput = $('.header-search-wrp #header-search');

  // Evento de clique no botão
  $searchBtnToggle.on('click', function (ev) {
    ev.preventDefault();
    toggleSearch();
  });

  // Exibe busca
  function showSearch() {
    $searchBtnToggle.addClass('active');
    $searchEl.slideDown('fast', function () {
      $searchInput.focus();
    });
  }

  // Oculta busca
  function hideSearch() {
    $searchBtnToggle.removeClass('active');
    $searchEl.slideUp('fast');
    $searchInput.val('');
  }

  // Exibe ou oculta a busca
  function toggleSearch() {
    if (!$searchBtnToggle.hasClass('active')) {
      showSearch();
    } else {
      hideSearch();
    }
  }

  // Exibe o busca ao voltar pro Desktop
  $(window).on(
    'hresize',
    debounce(function () {
      if (isMedia('xl') || isMedia('lg')) {
        showSearch();
      } else {
        hideSearch();
      }
    }, 100),
  );
})();

// Autocomplete
(function () {
  'use strict';
  if (!previewMode && $('#header-search').length > 0 && $('#header-search').hasClass('search-autocomplete')) {
    // Variáveis
    const urlSearch = urlBase + 'store/core/acoes/themes/' + baseTheme + '/busca_produtos.php';
    let urlSearchAll = urlBase + 'search/';
    const $searchInput = $('#header-search');
    const $searchCat = $('#header-search-category');
    const categoriasStore = $infosBase.data('categories');

    // Retorna o ID da categoria com base da slug passada
    function getCategoryID(catSlug) {
      if (categoriasStore) {
        const catFind = categoriasStore.filter((cat) => cat['seo_url'] == catSlug)[0];
        if (catFind) {
          return catFind.id;
        }
      }
      return false;
    }

    // Inicializa o plugin de busca
    $searchInput.autocomplete({
      serviceUrl: urlSearch,
      noCache: true,
      minChars: 3,
      width: '100%',
      zIndex: 2,
      appendTo: '.header-search-wrp',
      showNoSuggestionNotice: true,
      deferRequestBy: 100,
      maxHeight: 320,
      params: {
        category: $searchCat.val(),
        category_id: getCategoryID($searchCat.val()),
        store_token: publicToken
      },
      noSuggestionNotice: 'Nenhum produto encontrado.',
      onSelect: function (suggestion) {
        //console.log(suggestion);
        location.href = suggestion.data.url;
      },
      beforeRender: function (container) {
        container.append(
          '<a href="#" class="btn btn-full suggestions-see-all">Ver todos os resultados <svg viewBox="0 0 32 32"><path d="M 12.96875 4.28125 L 11.53125 5.71875 L 21.8125 16 L 11.53125 26.28125 L 12.96875 27.71875 L 23.96875 16.71875 L 24.65625 16 L 23.96875 15.28125 Z"/></svg></a>',
        );
      },
      onSearchStart: function (params) {
        $('.autocomplete-suggestions')
          .html(
            `<div class="suggestions-loading">
          <div class="suggestion-load">
            <div class="shimmer suggestion-load-img"></div>
            <div class="suggestion-load-infos">
              <div class="shimmer-text suggestion-load-title"></div>
              <div class="shimmer-text suggestion-load-price"></div>
            </div>
          </div>
          <div class="suggestion-load">
            <div class="shimmer suggestion-load-img"></div>
            <div class="suggestion-load-infos">
              <div class="shimmer-text suggestion-load-title"></div>
              <div class="shimmer-text suggestion-load-price"></div>
            </div>
          </div>
          <div class="suggestion-load">
            <div class="shimmer suggestion-load-img"></div>
            <div class="suggestion-load-infos">
              <div class="shimmer-text suggestion-load-title"></div>
              <div class="shimmer-text suggestion-load-price"></div>
            </div>
          </div>
        </div>`,
          )
          .show();
      },
      formatResult: function (suggestion, currentValue) {
        //console.log(suggestion);
        const prod = suggestion.data;
        let prodTitle = prod.title;
        const regex = new RegExp(currentValue, 'i');
        const match = prodTitle.match(regex);
        if (match && match[0]) {
          prodTitle = prodTitle.replace(match[0], '<strong>' + match[0] + '</strong>');
        }
        return `<div class="suggestion-prod">
          <div class="suggestion-prod-img"><img src="${prod.image}" /></div>
          <div class="suggestion-prod-infos">
            <div class="suggestion-prod-title">${prodTitle}</div>
            <div class="suggestion-prod-price">${prod.price}</div>
          </div>
        </div>`;
      },
    });

    // Ao alterar uma categoria
    $searchCat.on('change', function () {
      if ($searchInput.val() != '') {
        $searchInput.autocomplete('setOptions', {
          params: {
            category: $searchCat.val(),
            category_id: getCategoryID($searchCat.val()),
            store_token: publicToken
          },
        });
        $searchInput.autocomplete().onValueChange();
      }
    });

    // Ao clicar no botão para ver todos os resultados
    $('body').on('click', '.suggestions-see-all', function (ev) {
      ev.preventDefault();
      //console.log(getFullSearchURL());
      location.href = getFullSearchURL();
    });

    // Obtém a url de busca geral
    function getFullSearchURL() {
      const query = $searchInput.val();
      const category = $searchCat.val();
      /* if (category) {
        urlSearchAll = urlBase + category;
      } */
      return encodeURI(urlSearchAll + '?q=' + query);
    }
  }
})();
